import React, { useState } from "react";

import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { getAwsAssets } from "@src/utils";
import ContentLockedBottomSheet from "@src/components/BottomSheets/components/ContentLockedBottomSheet/ContentLockedBottomSheet";
import CourseLockedBottomSheet from "@src/components/BottomSheets/components/CourseLockedBottomSheet/CourseLockedBottomSheet";
import { initialisePaymentService } from "@src/PaymentService";

import Description from "./Description";
import WhatElse from "./WhatElse";
import CourseDetails from "./CourseDetails";

const AboutCourse = ({ overviewServerData, openModal }) => {
  const { t } = useTranslation();
  const state = useSelector((state) => {
    if (state?.overviewReducer?.overViewDetails?.course?.details?.name) {
      return state?.overviewReducer?.overViewDetails?.course;
    } else return overviewServerData?.course;
  });

  const purchaseViaWhatsappV2 = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.purchaseViaWhatsappV2
  );

  const purchaseViaWhatsapp = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.purchaseViaWhatsapp
  );

  const [showModal, setShowModal] = useState(false);
  const [isLockedModalOpen, setIsLockedModalOpen] = useState(false);

  const prePurchaseData = useSelector(state => state?.overviewReducer?.overViewDetails?.course?.metaData?.prePurchaseData);
  const postPurchaseData = useSelector(state => state?.overviewReducer?.overViewDetails?.course?.metaData?.postPurchaseData);
  const offlineMaterialFlag = useSelector(state => state?.overviewReducer?.overViewDetails?.course?.metaData?.offlineMaterialFlag);

  const purchaseCard = (data, type) => {
    return (
      <div className="newAdCard">
        <img src={data?.imageUrl} alt="" className="newAdCard__image" />
        <div className="newAdCard__detailsWrapper">
          <div className="newAdCard__headingWrapper">
            <div className="newAdCard__heading">{data?.heading}</div>
            <div className="newAdCard__subHeading">{data?.subHeading}</div>
          </div>
          <button
            className="newAdCard__button"
            onClick={
              type === "pre"
                ? () => setIsLockedModalOpen(true)
                : () => { 
                  window?.mobile?.onDeeplinkExecutedV2(JSON.stringify(data?.emblem?.deeplink))
                  window?.webkit?.messageHandlers?.onDeeplinkExecutedV2?.postMessage(JSON.stringify(data?.emblem?.deeplink));
                }
            }
          >
            {type === "pre" && (
              <img src={getAwsAssets("Rectangle.svg", "content")} alt="" />
            )}
            {data?.emblem.text}
            {type === "post" && (
              <img src={getAwsAssets("external-link.svg", "content")} alt="" />
            )}
          </button>
        </div>
      </div>
    );
  };

  return (
    <>
    {isLockedModalOpen && (
      <CourseLockedBottomSheet
        mainText={"Content is Locked"}
        subText={
          "The content you’re trying to open is locked. Buy the course for complete access."
        }
        btnText={purchaseViaWhatsapp || purchaseViaWhatsappV2 === 1 ? "I'm interested" : "Buy now"}
        btnAction={() => {
          setIsLockedModalOpen(false);
          initialisePaymentService();
        }}
        state={true}
        dispatcher={() => setIsLockedModalOpen(false)}
        showBtn={true}
      />
    )}
    <section className="AboutCourse">
      {state?.details?.description.trim() ? (
        <React.Fragment>
          <div className="AboutCourse__Heading">
            {" "}
            {offlineMaterialFlag ? "About this Book" : t(
              "components.tabs.overview.components.aboutCourse.aboutThisCourse.heading",
              "About This Course"
            )}
          </div>
          <div className="AboutCourse__Description">
            <Description
              desc={state?.details?.description}
              setShowModal={setShowModal}
            />
          </div>
        </React.Fragment>
      ) : null}
      {state?.durationText ? (
        <CourseDetails data={state} openModal={openModal} />
      ) : null}
      {state?.whatsIncluded?.length > 0 ? (
        <WhatElse data={state?.whatsIncluded} />
      ) : null}
      {(prePurchaseData || postPurchaseData) &&
        purchaseCard(
          prePurchaseData || postPurchaseData,
          prePurchaseData ? "pre" : "post"
        )}
    </section>
  </>
  );
};

const MemoizedAboutCourse = React.memo(AboutCourse);

export default MemoizedAboutCourse;
